import { useAppSelector } from '~/app/hooks'
import { isDarkTheme } from '~/redux/features'

export function MoreIcon() {
  const isDark = useAppSelector(isDarkTheme)
  return (
    <svg
      width='34'
      height='35'
      viewBox='0 0 34 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.2329 11.5269C15.8744 11.5269 14.7732 10.4256 14.7732 9.06716C14.7732 7.70868 15.8744 6.60742 17.2329 6.60742C18.5914 6.60742 19.6926 7.70868 19.6926 9.06716C19.6926 10.4256 18.5914 11.5269 17.2329 11.5269ZM17.2329 19.9603C15.8744 19.9603 14.7732 18.859 14.7732 17.5005C14.7732 16.1421 15.8744 15.0408 17.2329 15.0408C18.5914 15.0408 19.6926 16.1421 19.6926 17.5005C19.6926 18.859 18.5914 19.9603 17.2329 19.9603ZM14.7732 25.9339C14.7732 27.2924 15.8744 28.3937 17.2329 28.3937C18.5914 28.3937 19.6926 27.2924 19.6926 25.9339C19.6926 24.5754 18.5914 23.4742 17.2329 23.4742C15.8744 23.4742 14.7732 24.5754 14.7732 25.9339Z'
        fill={isDark ? 'var(--color-dark-theme)' : 'var(--color-light-theme)'}
      />
    </svg>
  )
}
